import React from "react";
import { useParams } from "react-router-dom";
import AppShell from "./AppShell";
import InfoCard from "./InfoCard";
import Error404 from "../404/404";
import { getApp } from "../../../Constants/Apps";
import { useDocumentTitle } from "../../../Hooks/useDocumentTitle";
import { useTranslation } from "../../../Hooks/useTranslation";

// Términos y condiciones de una app (solo las que los tienen, p. ej. Apptoto Local).
const AppTerms = () => {
  const { appId } = useParams();
  const { t } = useTranslation();
  const app = getApp(appId);
  useDocumentTitle(app ? `${t.apps.termsTitle} · ${app.name}` : undefined);

  return (
    <AppShell>
      {({ content, t }) =>
        !content.terms ? (
          <Error404 />
        ) : (
          <section className="section app-section">
            <div className="container">
              <div data-reveal>
                <span className="eyebrow">{t.apps.termsTitle}</span>
                <h2>{content.terms.intro}</h2>
                <p className="app-updated">{content.terms.date}</p>
              </div>
              <div className="row app-cards">
                {content.terms.sections.map((item, index) => (
                  <InfoCard key={item.title} item={item} writeUs={t.apps.writeUs} style={{ "--d": index % 3 }} />
                ))}
              </div>
            </div>
          </section>
        )
      }
    </AppShell>
  );
};

export default AppTerms;
